import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type TugboatMaterialItemData = {};

export const initialTugboatMaterialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
